export default __webpack_public_path__ + "static/media/1307.66c93297.jpg";